<template>
    <ul class="my-4">
        <li v-for="(item, index) in block.Items" :key="index" class="flex items-center mt-2">
            <svg class="w-3 h-3 text-gray-800" viewBox="0 0 24 24">
                <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" />
            </svg>
            <span class="ml-2">{{ item.Text }}</span>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "StandardList",
        data() {
            return {
                block: {
                    Items: [
                        { Text: 'This is the first list item' },
                        { Text: 'This is a middle list item' },
                        { Text: 'This is the last list item' }
                    ]
                }
            }
        }
    };
</script>